import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';

export const addDefaultFolderIdToNameMapInternal = mutatorAction(
    'addDefaultFolderIdToNameMapInternal',
    function setDefaultFolderIdToNameMapInternal(folderIdToNameMap: Map<string, string>) {
        const currentMap = getStore().defaultFolderIdToNameMap;
        getStore().defaultFolderIdToNameMap = new Map([...currentMap, ...folderIdToNameMap]);
    }
);
